const awsconfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scope: ["email", "openid", "profile"],
          //redirectSignIn: `${window.location.origin}/sessions`,
          //redirectSignOut: `${window.location.origin}/`,
          redirectSignIn: "https://appstream-bartec.mum-saas.de/sessions",
          redirectSignOut: "https://appstream-bartec.mum-saas.de/",
          responseType: "token",
        },
      },
    },
  },
};

export default awsconfig;
